<canvas
id="canvas{{index}}"
class="image-canvas"

[attr.url]="imageCarrosel"
style="display: none;"
></canvas>


<div *ngIf="loading" class="loader-overlay">
  <div class="loader"></div>
</div>
<img id="img{{index}}" *ngIf="cropedUrl" [src]="cropedUrl" class="image-canvas" alt="">
